import {css, unsafeCSS} from "lit";
import {sbkCoreBreakpointLg} from "@/tokens/variables";

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
    
    .repeatable-container {
        margin: 0 0 var(--sbkCoreSpacing3xl) 0;
    }

  .form-field {
    position: relative;
      border: none;
      margin: 0;
      padding: 0;
  }
    
    .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: var(--sbkTypographyLargeScrSm);
    }
    
    legend {
        padding: 0;
        max-width: var(--sbkCoreContentAreaTitelMaxWidth);
        font: var(--sbkTypographyContentSmallScrTitleLg);
        margin-bottom: var(--sbkTypographyLargeScrSm);

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkTypographyContentLargeScrTitleLg);
        }
    }

  sbk-modal {
      float: right;
  }

  .button-add {
    margin-top: var(--sbkCoreSpacing3xl);
  }
`;